import { render, staticRenderFns } from "./ProductPPLprice.vue?vue&type=template&id=51e40b8b&"
import script from "./ProductPPLprice.vue?vue&type=script&lang=js&"
export * from "./ProductPPLprice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports